import React, { useEffect } from "react";
import { useState } from "react";
import { useParams } from "react-router";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import { studyEDCDashboardGraph } from "../../../../APIServices/studyEDCDashboardGraph";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";
import AddEDCGraph from "./AddEDCGraph";
import AddStandardGraph from "./AddStandardGraph";

const AddNewDynamicGraph = ({ Show, Hide, setStandardGraphRefresh }) => {
    const { studyId } = useParams();
    const [actionType, setActionType] = useState("category");
    const [category, setCategory] = useState("");
    const [buttonLoader, setButtonLoader] = useState(false);
    const [subjectDataBy, setSubjectDataBy] = useState("");
    const [subjectDataValue, setSubjectDataValue] = useState("");
    const [graphName, setGraphName] = useState("");
    const [graphType, setGraphType] = useState("");
    const [yAxisName, setYAxisName] = useState("");
    const [xAxisName, setXAxisName] = useState("");
    const [siteType, setSiteType] = useState("");
    const [chartType, setChartType] = useState("");
    const [fieldId, setFieldId] = useState("");
    const [mainVersion, setMainVersion] = useState("");
    const [formId, setFormId] = useState("");
    const [version, setVersion] = useState("");
    const [fieldOption, setFieldOption] = useState("");
    const [colorOptions, setColorOptions] = useState([]);
    const [formMetadataList, setFormMetadataList] = useState([]);
    const [formFields, setFormFields] = useState([]);

    const getStudyLevelForm = async () => {
        let data = await studyLevelFormManagementServices.getStudyLevelForm(studyId, "edc", "active");
        setFormMetadataList(data?.data || []);
    };

    const getStudyLevelFormFieldsByVersion = async () => {
        let data = await studyLevelFormManagementServices.getStudyLevelFormFieldsByVersion(
            studyId,
            formId,
            version
        );
        setFormFields(data?.data?.formFields || []);
    };

    const addNewEDCDashboardGraph = async () => {
        setButtonLoader(true)
        let userData = {}
        userData.studyId = studyId
        userData.category = category
        userData.siteType = siteType
        userData.subjectDataBy = subjectDataBy
        userData.subjectDataValue = subjectDataValue
        userData.graphType = graphType
        userData.chartType = chartType
        userData.yAxisName = yAxisName
        userData.xAxisName = xAxisName
        userData.graphName = graphName
        if(fieldOption){
            userData.fieldOption = JSON.parse(fieldOption)
        }
        userData.colorOptions = colorOptions
        userData.formId = formId
        userData.version = version
        userData.fieldId = fieldId
        let data = await studyEDCDashboardGraph.addNewEDCDashboardGraph(userData)
        if (data?.statusCode === 200) {
            Hide()
            setCategory("")
            setSubjectDataBy("")
            setSubjectDataValue("")
            setGraphName("")
            setSiteType("")
            setGraphType("")
            setChartType("")
            setYAxisName("")
            setXAxisName("")
            setFieldOption("")
            setFieldId("")
            setFormId("")
            setVersion("")
            setStandardGraphRefresh(Math.floor(1000000000 + Math.random() * 9000000000));
        }
        setButtonLoader(false)
    }

    useEffect(() => {
        setActionType("category")
        setCategory("")
        setSubjectDataBy("")
        setSubjectDataValue("")
        setGraphName("")
        setGraphType("")
        setSiteType("")
        setChartType("")
        setFieldOption("")
        setYAxisName("")
        setXAxisName("")
        setFieldId("")
        setFormId("")
        setVersion("")
    }, [Show]);

    useEffect(() => {
        if (category === "edc") {
            getStudyLevelForm();
        }
    }, [studyId, category]);

    useEffect(() => {
        if((subjectDataBy === "screenStatus" && subjectDataValue === "allStatus")){
            setColorOptions([
                {
                    option: subjectDataBy === "screenStatus" ? "Screening Passed Subject" :
                        subjectDataBy === "randomizationStatus" ? "Randomized Subject" :
                            subjectDataBy === "discontinueStatus" ? "Discontinue Subject" :
                                subjectDataBy === "completedStatus" ? "Completed Subject" : "",
                    color: "#000000"
                },
                {
                    option: subjectDataBy === "screenStatus" ? "Screening Failed Subject" :
                        subjectDataBy === "randomizationStatus" ? "No Randomized Subject" :
                            subjectDataBy === "discontinueStatus" ? "Continue Subject" :
                                subjectDataBy === "completedStatus" ? "Incompleted Subject" : "",
                    color: "#000000"
                }
            ])
        }
    }, [subjectDataBy, subjectDataValue]);

    const handleEDCColorChange = (e, index) => {
        const selectedColor = e.target.value;
        const updatedOptions = JSON.parse(fieldOption).map((opt, i) =>
            i === index ? { ...opt, color: selectedColor } : opt
        );
        setFieldOption(JSON.stringify(updatedOptions));
    };

    const handleStandardColorChange = (index, value) => {
        const updated = [...colorOptions];
        updated[index].color = value;
        setColorOptions(updated);
    };

    useEffect(() => {
        if (formId && version && category === "edc") {
            getStudyLevelFormFieldsByVersion()
        }
    }, [formId, version, category]);
    
    return (
        <>
            <Offcanvas
                show={Show}
                onHide={Hide}
                placement="end"
                style={{ width: 600 }}
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Select Chart Properties</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    {actionType === "category" &&
                        <>
                            <Form.Group className="mb-1">
                                <Form.Label className="fw-bold mb-1">
                                    Category{" "}
                                    <abbr title="Required" className="text-danger">
                                        *
                                    </abbr>
                                </Form.Label>
                                <Form.Select
                                    onChange={(e) => setCategory(e.target.value)}
                                    className="br3"
                                    style={{ fontSize: 12 }}
                                >
                                    <option selected={category === ""} value="">Select Category</option>
                                    <option selected={category === "standard"} value="standard">Standard</option>
                                    <option selected={category === "edc"} value="edc">EDC</option>
                                </Form.Select>
                            </Form.Group>
                            {category &&
                                <Form.Group className="mb-1">
                                    <Form.Label className="fw-bold mb-1">
                                        Site Type{" "}
                                        <abbr title="Required" className="text-danger">
                                            *
                                        </abbr>
                                    </Form.Label>
                                    <Form.Select
                                        onChange={(e) => { setSiteType(e.target.value); setChartType(""); setGraphType("") }}
                                        className="br3"
                                        style={{ fontSize: 12 }}
                                    >
                                        <option selected={siteType === ""} value="">Site Type</option>
                                        <option selected={siteType === "overAll"} value="overAll">Over All</option>
                                        <option selected={siteType === "siteWise"} value="siteWise">Site Wise</option>
                                    </Form.Select>
                                </Form.Group>
                            }
                        </>
                    }
                    {category === "standard" &&
                        <AddStandardGraph
                            actionType={actionType}
                            subjectDataBy={subjectDataBy}
                            setSubjectDataBy={setSubjectDataBy}
                            subjectDataValue={subjectDataValue}
                            setSubjectDataValue={setSubjectDataValue}
                            graphName={graphName}
                            setGraphName={setGraphName}
                            graphType={graphType}
                            setGraphType={setGraphType}
                            yAxisName={yAxisName}
                            setYAxisName={setYAxisName}
                            xAxisName={xAxisName}
                            setXAxisName={setXAxisName}
                            siteType={siteType}
                            chartType={chartType}
                            setChartType={setChartType}
                            colorOptions={colorOptions}
                            setColorOptions={setColorOptions}
                            handleStandardColorChange={handleStandardColorChange}
                        />
                    }
                    {category === "edc" &&
                        <AddEDCGraph
                            actionType={actionType}
                            graphName={graphName}
                            setGraphName={setGraphName}
                            graphType={graphType}
                            setGraphType={setGraphType}
                            yAxisName={yAxisName}
                            setYAxisName={setYAxisName}
                            xAxisName={xAxisName}
                            setXAxisName={setXAxisName}
                            chartType={chartType}
                            setChartType={setChartType}
                            fieldId={fieldId}
                            setFieldId={setFieldId}
                            mainVersion={mainVersion}
                            setMainVersion={setMainVersion}
                            formId={formId}
                            setFormId={setFormId}
                            version={version}
                            setVersion={setVersion}
                            formMetadataList={formMetadataList}
                            formFields={formFields}
                            siteType={siteType}
                            setFieldOption={setFieldOption}
                            fieldOption={fieldOption}
                            handleEDCColorChange={handleEDCColorChange}
                        />
                    }
                </Offcanvas.Body>
                {category === "standard" &&
                    <div className="hstack justify-content-end p-2 border-top shadow-sm bg-light">
                        <div className="hstack gap-2">
                            {actionType !== "category" &&
                                <button
                                    onClick={() => {
                                        if (actionType === "graph") {
                                            setActionType("category")
                                        }
                                    }}
                                    className="updateProfile"
                                >
                                    Back
                                </button>
                            }
                            <button
                                onClick={() => {
                                    if ((actionType === "category")) {
                                        setActionType("graph")
                                    }
                                    if (actionType === "graph") {
                                        addNewEDCDashboardGraph()
                                    }
                                }}
                                className="updateProfile"
                            >
                                {buttonLoader ? (
                                    <div className="hstack gap-1">
                                        <Spinner size="sm" /> Adding...
                                    </div>
                                ) : (
                                    actionType === "graph" ? "Add" : "Save & Next"
                                )}
                            </button>
                        </div>
                    </div>
                }
                {category === "edc" &&
                    <div className="hstack justify-content-end p-2 border-top shadow-sm bg-light">
                        <div className="hstack gap-2">
                            {actionType !== "category" &&
                                <button
                                    // disabled={buttonLoader}
                                    onClick={() => {
                                        if (actionType === "graph") {
                                            setActionType("category")
                                        }
                                    }}
                                    className="updateProfile"
                                >
                                    Back
                                </button>
                            }
                            <button
                                onClick={() => {
                                    if ((actionType === "category")) {
                                        setActionType("graph")
                                    }
                                    if (actionType === "graph") {
                                        addNewEDCDashboardGraph()
                                    }
                                }}
                                // disabled={buttonLoader}
                                className="updateProfile"
                            >
                                {buttonLoader ? (
                                    <div className="hstack gap-1">
                                        <Spinner size="sm" /> Adding...
                                    </div>
                                ) : (
                                    actionType === "graph" ? "Add" : "Save & Next"
                                )}
                            </button>
                        </div>
                    </div>
                }
            </Offcanvas>
        </>
    );
};

export default AddNewDynamicGraph;
